var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cr-contianer" }, [
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.getTitle()))]),
    _vm._v(" "),
    _c("div", { staticStyle: { height: "100%", position: "relative" } }, [
      _vm.crmType == ""
        ? _c(
            "div",
            { staticClass: "cr-body-side" },
            _vm._l(_vm.leftSides, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "side-item",
                  class:
                    _vm.leftType === item.type
                      ? "side-item-select"
                      : "side-item-default",
                  on: {
                    click: function ($event) {
                      return _vm.sideClick(item)
                    },
                  },
                },
                [
                  _vm._v(_vm._s(item.name) + "\n        "),
                  _vm.getMenuCrmNum(item.type)
                    ? _c("span", { staticClass: "side-item__num" }, [
                        _vm._v(_vm._s(`(${_vm.getMenuCrmNum(item.type)})`)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { style: { "padding-left": _vm.crmType == "" ? "150px" : "0" } },
        _vm._l(_vm.leftSides, function (item, index) {
          return _c("crm-relative-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.type == _vm.leftType,
                expression: "item.type == leftType",
              },
            ],
            key: index,
            ref: "crm" + item.type,
            refInFor: true,
            attrs: {
              show: _vm.show && item.type == _vm.leftType,
              radio: _vm.radio,
              "crm-type": item.type,
              "selected-data": _vm.currentSelectedData,
              action: _vm.action,
            },
            on: { changeCheckout: _vm.checkCrmTypeInfos },
          })
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c("el-button", { on: { click: _vm.closeView } }, [_vm._v("取消")]),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.confirmClick } },
          [_vm._v("确定")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }